import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
const ChartWrapper = defineAsyncComponent(() => import('@/js/cryptocurrencies/ChartWrapper.vue'));
const ShareIcons = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareIcons.vue'));
const ShareTippy = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareTippy.vue'));
const LearnListButton = defineAsyncComponent(() => import('@/js/global/buttons/LearnListButton.vue'));
const TopExchangesTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TopExchangesTippy/TopExchangesTippy.vue'));

app.component('Converter', Converter);
app.component('ChartWrapper', ChartWrapper);
app.component('ShareIcons', ShareIcons);
app.component('LearnListButton', LearnListButton);
app.component('ShareTippy', ShareTippy);
app.component('TopExchangesTippy', TopExchangesTippy);

mountApp();
